var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useCallback, useMemo } from "react";
import { Pane, Button, Checkbox, MenuSection, TextLink, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useMutation, useQueryClient } from "react-query";
import { useIntl, FormattedMessage } from "react-intl";
import NavComponent from "../../components/NavComponent";
import TableComponent from "../../components/TableComponent";
import { PeriodicalFilters } from "../../components/PeriodicalFilters";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { RowClickBoundary } from "../../components/RowClickBoundary";
import { BulkSubscribePeriodicalsDialog } from "../../components/periodical/BulkSubscribePeriodicalsDialog";
import { BulkExcludePeriodicalsDialog } from "../../components/periodical/BulkExcludePeriodicalsDialog";
import { SelectAllBanner } from "../../components/selection/SelectAllBanner";
import { createStripesSource } from "../../utils/createStripesSource";
import { formatCountSubtitle } from "../../utils/paneCount";
import { buildPeriodicalSelection } from "../../utils/buildTitleSelection";
import { hasHttpResponse } from "../../utils/apiUtils";
import { frequencyLabelId } from "../../utils/frequencyLabel";
import { subscribePeriodicalsBulk, excludePeriodicalsBulk, } from "../../api/periodicalLibraryService";
import { ProvisionalBadge } from "../../components/common/ProvisionalBadge";
import { NameCell } from "../../components/common/NameCell";
import { provisionalKey } from "../../utils/provisionalTitleKeys";
import { MAX_SELECTION_SIZE, } from "../../types/selection";
import { useNewPeriodicalsData } from "../../hooks/useNewPeriodicalsData";
import { useNewPeriodicalActions } from "../../hooks/useNewPeriodicalActions";
import { usePeriodicalFilters } from "../../hooks/usePeriodicalFilters";
import { usePublishersData } from "../../hooks/usePublishersData";
import { usePeriodicalLibraryActions } from "../../hooks/usePeriodicalLibraryActions";
import { usePermissions } from "../../hooks/usePermissions";
import { ProvisionalTitleModal } from "../../components/title/ProvisionalTitleModal";
import { useSelection } from "../../hooks/useSelection";
import { useTitleSort } from "../../hooks/useTitleSort";
import { useListErrorMessage } from "../../hooks/useListErrorMessage";
import { columnSortKeys } from "../../utils/titleSort";
import { useVariantTitlesColumn, VARIANT_TITLES_COLUMN_WIDTH, } from "../../hooks/useVariantTitlesColumn";
import { VariantTitlesList } from "../../components/common/VariantTitlesList";
import css from "./NewPeriodicalsList.module.css";
export var NewPeriodicalsList = function () {
    var _a, _b, _c, _d;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _e = useState(true), filterPaneIsVisible = _e[0], setFilterPaneIsVisible = _e[1];
    var _f = useState(false), showBulkSubscribeDialog = _f[0], setShowBulkSubscribeDialog = _f[1];
    var _g = useState(false), showBulkExcludeDialog = _g[0], setShowBulkExcludeDialog = _g[1];
    var _h = useState(false), showSingleExcludeDialog = _h[0], setShowSingleExcludeDialog = _h[1];
    var _j = useState(null), bulkErrorMessage = _j[0], setBulkErrorMessage = _j[1];
    var _k = useState(false), provisionalModalOpen = _k[0], setProvisionalModalOpen = _k[1];
    var _l = useState(null), provisionalInfoMessage = _l[0], setProvisionalInfoMessage = _l[1];
    var canVerifyTitleItem = usePermissions().canVerifyTitleItem;
    var _m = usePeriodicalLibraryActions(), selectedItem = _m.selectedItem, handleRowClick = _m.handleRowClick, handleCloseDetail = _m.handleCloseDetail;
    var selectedPeriodical = selectedItem;
    var filtersHook = usePeriodicalFilters();
    var _o = usePublishersData(filtersHook.publisherQuery, filtersHook.filters.publisherId, "PERIODICAL_PENDING"), publishers = _o.publishers, isPublishersLoading = _o.isPublishersLoading, selectedPublisher = _o.selectedPublisher;
    var variantTitlesColumn = useVariantTitlesColumn();
    var dataColumns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.periodicals.table.title",
            }),
            key: "title",
            sortKey: "name",
            alwaysVisible: true,
            cellRenderer: function (item) { return (React.createElement(NameCell, null,
                React.createElement(TextLink, { onClick: function (e) {
                        e.stopPropagation();
                        handleRowClick(item);
                    } }, item.title),
                item.provisional && React.createElement(ProvisionalBadge, null))); },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.titles.table.partNumber",
            }),
            key: "partNumber",
            sortKey: "partNumber",
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.titles.table.partName",
            }),
            key: "partName",
            sortKey: "partName",
        },
        variantTitlesColumn,
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.periodicals.table.issn",
            }),
            key: "issn",
            sortKey: "issn",
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.periodicals.table.publisher",
            }),
            key: "publisherName",
            sortKey: "publisher",
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.periodicals.table.frequency",
            }),
            key: "frequency",
            sortKey: "frequency",
            cellRenderer: function (item) {
                return item.frequency
                    ? formatMessage({ id: frequencyLabelId(item.frequency) })
                    : "";
            },
        },
    ]; }, [formatMessage, handleRowClick, variantTitlesColumn]);
    var sortKeys = useMemo(function () { return columnSortKeys(dataColumns); }, [dataColumns]);
    var _p = useTitleSort("newPeriodicals", sortKeys), sort = _p.sort, handleSort = _p.handleSort;
    var dataHook = useNewPeriodicalsData(filtersHook.appliedFilters, sort);
    var errorMessage = useListErrorMessage(dataHook.error);
    var _q = useNewPeriodicalActions(), handleSubscribe = _q.handleSubscribe, handleExclude = _q.handleExclude, isSubscribing = _q.isSubscribing, isExcluding = _q.isExcluding;
    var pageIds = useMemo(function () { return dataHook.periodicalsData.map(function (p) { return p.id; }).filter(Boolean); }, [dataHook.periodicalsData]);
    var totalCount = (_a = dataHook.totalRecords) !== null && _a !== void 0 ? _a : pageIds.length;
    var matchFilter = useMemo(function () { return ({
        name: filtersHook.appliedFilters.name || undefined,
        issn: filtersHook.appliedFilters.issn || undefined,
        publisherId: filtersHook.appliedFilters.publisherId || undefined,
        frequencies: filtersHook.appliedFilters.frequencies.length > 0
            ? filtersHook.appliedFilters.frequencies
            : undefined,
        provisional: filtersHook.appliedFilters.provisional || undefined,
    }); }, [filtersHook.appliedFilters]);
    var selection = useSelection({
        pageIds: pageIds,
        totalCount: totalCount,
        exactTotalCount: dataHook.exactTotalRecords,
        isCountCapped: dataHook.isCountCapped,
        filterDeps: [filtersHook.appliedFilters],
    });
    var toggleFilterPane = useCallback(function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); }, []);
    var handleSubscribeClick = useCallback(function (id) {
        handleSubscribe(id, {
            onSuccess: function () { return handleCloseDetail(); },
        });
    }, [handleSubscribe, handleCloseDetail]);
    var handleExcludeSubmit = useCallback(function (id, reason, note) {
        handleExclude({ id: id, reason: reason, note: note }, {
            onSuccess: function () {
                setShowSingleExcludeDialog(false);
                handleCloseDetail();
            },
        });
    }, [handleExclude, handleCloseDetail]);
    var checkboxColumn = useMemo(function () { return ({
        name: (React.createElement(Checkbox, { checked: selection.isAllPageSelected, onChange: selection.togglePage })),
        key: "select",
        locked: true,
        cellRenderer: function (item) {
            var isChecked = selection.isRowSelected(item.id);
            var isLocked = selection.mode === "all";
            return (React.createElement(RowClickBoundary, { className: isChecked ? css.checkboxActive : css.checkboxMuted },
                React.createElement(Checkbox, { checked: isChecked, disabled: isLocked, onChange: function () { return selection.toggleRow(item.id); } })));
        },
    }); }, [selection]);
    var columns = useMemo(function () { return __spreadArray([checkboxColumn], dataColumns, true); }, [checkboxColumn, dataColumns]);
    var columnWidths = useMemo(function () { return ({
        select: "4%",
        title: "24%",
        partNumber: "8%",
        partName: "10%",
        variantTitles: VARIANT_TITLES_COLUMN_WIDTH,
        issn: "12%",
        publisherName: "26%",
        frequency: "16%",
    }); }, []);
    var source = useMemo(function () {
        return createStripesSource({
            ky: null,
            data: dataHook.periodicalsData,
            totalRecords: dataHook.totalRecords,
            isLoading: dataHook.isLoading,
            isError: dataHook.isError,
            errorMessage: errorMessage,
            isLoaded: true,
            fetchMore: function () {
                return dataHook.fetchMoreData(dataHook.pageOffset + dataHook.pageSize);
            },
        });
    }, [dataHook, errorMessage]);
    var handleNeedMoreData = useCallback(function (offset) { return dataHook.fetchMoreData(offset); }, [dataHook]);
    var afterBulkSuccess = useCallback(function () {
        selection.clearSelection();
        setBulkErrorMessage(null);
        queryClient.invalidateQueries(["periodicalLibraries"]);
    }, [selection, queryClient]);
    var handleBulkError = useCallback(function (err) { return __awaiter(void 0, void 0, void 0, function () {
        var body, _a, message;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(hasHttpResponse(err) && err.response.status === 422)) return [3 /*break*/, 5];
                    body = null;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, err.response.clone().json()];
                case 2:
                    body = _d.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _d.sent();
                    body = null;
                    return [3 /*break*/, 4];
                case 4:
                    message = (body === null || body === void 0 ? void 0 : body.message) ||
                        ((_c = (_b = body === null || body === void 0 ? void 0 : body.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message) ||
                        formatMessage({
                            id: "ui-br-legaldeposits.selection.limitExceeded.error",
                        });
                    setBulkErrorMessage(message);
                    return [2 /*return*/];
                case 5:
                    setBulkErrorMessage(formatMessage({ id: "ui-br-legaldeposits.bulk.error.generic" }));
                    return [2 /*return*/];
            }
        });
    }); }, [formatMessage]);
    var buildPayload = useCallback(function () {
        return buildPeriodicalSelection({
            mode: selection.mode,
            includeIds: selection.includeIds,
            excludeIds: selection.excludeIds,
        }, matchFilter);
    }, [selection.mode, selection.includeIds, selection.excludeIds, matchFilter]);
    var subscribeBulkMutation = useMutation(function () { return subscribePeriodicalsBulk(kyInstance, buildPayload()); }, {
        onSuccess: function () {
            setShowBulkSubscribeDialog(false);
            afterBulkSuccess();
        },
        onError: handleBulkError,
    });
    var excludeBulkMutation = useMutation(function (_a) {
        var reason = _a.reason, note = _a.note;
        return excludePeriodicalsBulk(kyInstance, buildPayload(), reason, note);
    }, {
        onSuccess: function () {
            setShowBulkExcludeDialog(false);
            afterBulkSuccess();
        },
        onError: handleBulkError,
    });
    var detailActionMenu = function () { return (React.createElement(MenuSection, { label: formatMessage({
            id: "ui-br-legaldeposits.action.menu.label",
        }), id: "actions-menu" },
        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () { return handleSubscribeClick(selectedItem.id); }, disabled: isSubscribing, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.action.subscribe" })),
        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () { return setShowSingleExcludeDialog(true); }, disabled: isExcluding, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.action.exclude" })))); };
    var bulkActionMenu = function () { return (React.createElement(React.Fragment, null,
        canVerifyTitleItem && (React.createElement(MenuSection, { id: "new-periodicals-list-actions", label: formatMessage({ id: "ui-br-legaldeposits.action.menu.label" }) },
            React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () {
                    setProvisionalInfoMessage(null);
                    setProvisionalModalOpen(true);
                } },
                React.createElement(FormattedMessage, { id: provisionalKey("PERIODICAL", "action") })))),
        React.createElement(MenuSection, { id: "bulk-actions-menu", label: formatMessage({ id: "ui-br-legaldeposits.bulk.actions.label" }) },
            React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: selection.selectedCount === 0, onClick: function () {
                    setBulkErrorMessage(null);
                    setShowBulkSubscribeDialog(true);
                } },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.bulk.actions.subscribeSelected", values: { count: selection.selectedCount } })),
            React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: selection.selectedCount === 0, onClick: function () {
                    setBulkErrorMessage(null);
                    setShowBulkExcludeDialog(true);
                } },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.bulk.actions.excludeSelected", values: { count: selection.selectedCount } }))))); };
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.pane.title.navigation",
            }) },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement(NavComponent, null),
                React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !filtersHook.isAnyFilterActive(), marginBottom0: true, onClick: filtersHook.handleClearFilters },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.resetAll" })),
                React.createElement(PeriodicalFilters, { filters: filtersHook.filters, libraryStatus: filtersHook.appliedFilters.libraryStatus, publishers: publishers, isPublishersLoading: isPublishersLoading, selectedPublisher: selectedPublisher, onFilterChange: filtersHook.handleFilterChange, onFrequencyChange: filtersHook.handleFrequencyChange, onLibraryStatusChange: filtersHook.handleLibraryStatusChange, onProvisionalChange: filtersHook.handleProvisionalChange, onPublisherInput: filtersHook.handlePublisherInput, onApplyFilters: filtersHook.handleApplyFilters, hasUnappliedChanges: filtersHook.hasUnappliedChanges() })))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.navigation.new-periodicals",
            }), paneSub: formatCountSubtitle(formatMessage, dataHook.totalRecords, dataHook.isCountCapped), actionMenu: bulkActionMenu },
            React.createElement(SelectAllBanner, { mode: selection.mode, selectedCount: selection.selectedCount, pageRecordCount: pageIds.length, totalCount: totalCount, exactTotalCount: dataHook.exactTotalRecords, isCountCapped: dataHook.isCountCapped, limit: MAX_SELECTION_SIZE, onSelectAllAcrossFilter: selection.selectAllAcrossFilter, onClear: selection.clearSelection }),
            provisionalInfoMessage && (React.createElement("div", { role: "status", className: css.provisionalInfo }, provisionalInfoMessage)),
            bulkErrorMessage && (React.createElement("div", { role: "alert", className: css.bulkError }, bulkErrorMessage)),
            React.createElement(TableComponent, { data: dataHook.periodicalsData, columns: columns, columnPrefsKey: "periodicals.new", columnWidths: columnWidths, pageSize: dataHook.pageSize, onPageSizeChange: dataHook.changePageSize, totalCount: dataHook.totalRecords, onNeedMoreData: handleNeedMoreData, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source, isFetching: dataHook.isFetching, onRowClick: handleRowClick, sortBy: sort.sortBy, sortDir: sort.sortDir, onSort: handleSort, resetPaginationKey: "".concat(JSON.stringify(filtersHook.appliedFilters), "|").concat(sort.sortBy, "|").concat(sort.sortDir) })),
        selectedItem && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: (_b = selectedItem.title) !== null && _b !== void 0 ? _b : "", onClose: handleCloseDetail, dismissible: true, actionMenu: detailActionMenu },
            React.createElement("div", null,
                (selectedPeriodical === null || selectedPeriodical === void 0 ? void 0 : selectedPeriodical.provisional) && (React.createElement("p", null,
                    React.createElement(ProvisionalBadge, null))),
                React.createElement("p", null,
                    React.createElement("strong", null,
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.field.issn" }),
                        ":"),
                    " ", (_c = selectedItem.issn) !== null && _c !== void 0 ? _c : "—"),
                React.createElement(VariantTitlesList, { variants: selectedItem.variantTitles }),
                React.createElement("p", null,
                    React.createElement("strong", null,
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.field.publisher" }),
                        ":"),
                    " ", (_d = selectedItem.publisherName) !== null && _d !== void 0 ? _d : "—"),
                React.createElement("p", null,
                    React.createElement("strong", null,
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.field.frequency" }),
                        ":"),
                    " ",
                    selectedItem.frequency
                        ? formatMessage({
                            id: frequencyLabelId(selectedItem.frequency),
                        })
                        : "—"),
                (selectedPeriodical === null || selectedPeriodical === void 0 ? void 0 : selectedPeriodical.provisionalNote) && (React.createElement("p", null,
                    React.createElement("strong", null,
                        React.createElement(FormattedMessage, { id: provisionalKey("PERIODICAL", "field.note") }),
                        ":"),
                    " ",
                    selectedPeriodical.provisionalNote))))),
        React.createElement(BulkSubscribePeriodicalsDialog, { open: showBulkSubscribeDialog, selectedCount: selection.selectedCount, onClose: function () { return setShowBulkSubscribeDialog(false); }, onSubmit: function () { return subscribeBulkMutation.mutate(); }, isLoading: subscribeBulkMutation.isLoading }),
        React.createElement(BulkExcludePeriodicalsDialog, { open: showBulkExcludeDialog, selectedCount: selection.selectedCount, onClose: function () { return setShowBulkExcludeDialog(false); }, onSubmit: function (reason, note) {
                return excludeBulkMutation.mutate({ reason: reason, note: note });
            }, isLoading: excludeBulkMutation.isLoading }),
        React.createElement(ProvisionalTitleModal, { open: provisionalModalOpen, onClose: function () { return setProvisionalModalOpen(false); }, titleType: "PERIODICAL", onCreated: function (_a) {
                var pairedWithRegistryPublisher = _a.pairedWithRegistryPublisher;
                return setProvisionalInfoMessage(formatMessage({
                    id: pairedWithRegistryPublisher
                        ? "ui-br-legaldeposits.provisionalPeriodical.created.inList"
                        : "ui-br-legaldeposits.provisionalPeriodical.created.forVerification",
                }));
            } }),
        React.createElement(BulkExcludePeriodicalsDialog, { open: showSingleExcludeDialog, selectedCount: 1, onClose: function () { return setShowSingleExcludeDialog(false); }, onSubmit: function (reason, note) {
                if (selectedItem) {
                    handleExcludeSubmit(selectedItem.id, reason, note);
                }
            }, isLoading: isExcluding })));
};
